<template>
  <Line :data="chartData" :options="chartOptions" />
</template>

<script setup>
import { computed } from "vue";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "vue-chartjs";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);
const props = defineProps({
  data: {
    type: Array,
    required: true,
  },
  labels: {
    type: Array,
    required: true,
  },
});
function getFgColor() {
  return (
    getComputedStyle(document.documentElement)
      .getPropertyValue("--fg1")
      .trim() || "#222"
  );
}
const chartData = computed(() => ({
  labels: props.labels,
  datasets: props.data,
}));
const chartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: true,
      position: "top",
      align: "center",
      labels: {
        color: getFgColor(),
      },
    },
  },
  scales: {
    x: {
      ticks: {
        color: getFgColor(),
      },
      grid: {
        color: getFgColor(),
      },
    },
    y: {
      ticks: {
        color: getFgColor(),
      },
      grid: {
        color: getFgColor(),
      },
    },
  },
};
</script>
